// @flow
import * as Base64 from './lib/Base64';
import * as Color from './lib/Color';
import ExamplesSection from './components/ExamplesSection';
import InfoSection from './components/InfoSection';
import LinksSection from './components/LinksSection';
import NavBar from './components/NavBar';
import QueryString from 'query-string';
import React, { Component } from 'react';
import { Container, Footer } from 'rebass';
import { spoonerizePhrase } from './lib/Spoonerism';
import SpoonerismBanner from './components/SpoonerismBanner';

const DEFAULT_SPOONERISM = 'spoonerism dot org';

class App extends Component {
  state = {
    phrase: '',
  };

  componentWillMount() {
    const { s } = QueryString.parse(location.search);
    this.setState({phrase: Base64.decode(s)});
  }

  componentDidMount() {
    this.setTitle();
  }

  componentDidUpdate() {
    this.setTitle();
  }

  getSpoonerism() {
    return spoonerizePhrase(this.state.phrase || DEFAULT_SPOONERISM);
  }

  handleSpoonerismChange(phrase: string) {
    this.setState({phrase}, () => {
      const search = `?${QueryString.stringify({s: Base64.encode(phrase)})}`;
      history.replaceState(null, phrase, search);
      window.scroll(0, 0);
    });
  }

  setTitle() {
    if (!this.state.phrase) {
      document.title = 'spoonerism.org';
    } else {
      document.title = `${this.getSpoonerism()} - spoonerism.org`;
    }
  }

  render() {
    const { phrase } = this.state;
    const spoonerism = this.getSpoonerism();
    const background = Color.forString(spoonerism);
    const foreground = Color.complement(background);
    return (
      <div>
        <NavBar
          background={background}
          foreground={foreground}
        />
        <SpoonerismBanner
          background={background}
          foreground={foreground}
          onChange={this.handleSpoonerismChange.bind(this)}
          phrase={phrase}
          spoonerism={spoonerism}
        />
        <Container>
          <InfoSection />
          <ExamplesSection />
          <LinksSection />
          <Footer>
            <a href="http://colbyr.com">
              Colby Rabideau
            </a>
          </Footer>
        </Container>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/